module.exports = __webpack_public_path__ + "static/img/twjd-sdo12.9661331.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo12.png
// module id = 854
// module chunks = 0